import {
  Component,
  forwardRef,
  OnInit,
  viewChild,
  ChangeDetectionStrategy
} from '@angular/core';

import { NgControl, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';

import { AppFormFieldControl } from '../../form-field/form-field-control/form-field-control';
import { BaseControl } from '../base-control';

@Component({
  selector: 'app-time',
  templateUrl: './time.component.html',
  styleUrls: ['./time.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TimeComponent),
      multi: true
    },
    {
      provide: AppFormFieldControl,
      useExisting: forwardRef(() => TimeComponent)
    }
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule]
})
export class TimeComponent extends BaseControl<boolean> implements OnInit {
  readonly ngControl = viewChild(NgControl);

  ngOnInit() {
    this.ngControl().statusChanges.subscribe(() => this.stateChanges.next());
  }
}
